'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _omit = require('../utils/underscore/omit');

var _omit2 = _interopRequireDefault(_omit);

var _UIModalDialog = require('./UIModalDialog');

var _UIModalDialog2 = _interopRequireDefault(_UIModalDialog);

var _decorators = require('../utils/propTypes/decorators');

var _PanelContext = require('../context/PanelContext');

var PanelContext = _interopRequireWildcard(_PanelContext);

var _ModalPanelTransition = require('./internal/ModalPanelTransition');

var _ModalPanelTransition2 = _interopRequireDefault(_ModalPanelTransition);

var _AbstractModal = require('./internal/AbstractModal');

var _AbstractModal2 = _interopRequireDefault(_AbstractModal);

var _Functions = require('../core/Functions');

var _BrowserTest = require('../utils/BrowserTest');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var inPanelContext = { inPanel: true };

var UIModalPanel = function (_PureComponent) {
  _inherits(UIModalPanel, _PureComponent);

  function UIModalPanel(props) {
    _classCallCheck(this, UIModalPanel);

    var _this = _possibleConstructorReturn(this, (UIModalPanel.__proto__ || Object.getPrototypeOf(UIModalPanel)).call(this, props));

    _this.handleOpenStart = _this.handleOpenStart.bind(_this);
    _this.handleOpenComplete = _this.handleOpenComplete.bind(_this);
    return _this;
  }

  _createClass(UIModalPanel, [{
    key: 'handleOpenStart',
    value: function handleOpenStart() {
      var onOpenStart = this.props.onOpenStart;

      (0, _Functions.callIfPossible)(onOpenStart);

      // Safari glitches the transition if an element in the modal panel is focused (#6033)
      if ((0, _BrowserTest.isSafari)()) {
        this._autoFocusedEl = document.activeElement;
        this._autoFocusedEl.blur();
      }
    }
  }, {
    key: 'handleOpenComplete',
    value: function handleOpenComplete() {
      var onOpenComplete = this.props.onOpenComplete;

      (0, _Functions.callIfPossible)(onOpenComplete);

      if ((0, _BrowserTest.isSafari)()) {
        this._autoFocusedEl.focus();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          __panelKey = _props.panelKey,
          width = _props.width,
          rest = _objectWithoutProperties(_props, ['panelKey', 'width']);

      return _react2.default.createElement(
        PanelContext.Provider,
        { value: inPanelContext },
        _react2.default.createElement(_AbstractModal2.default, _extends({}, rest, {
          _use: 'sidebar',
          _dialogWidth: width,
          componentName: 'UIModalPanel',
          Transition: _ModalPanelTransition2.default,
          onOpenStart: this.handleOpenStart,
          onOpenComplete: this.handleOpenComplete
        }))
      );
    }
  }]);

  return UIModalPanel;
}(_react.PureComponent);

UIModalPanel.propTypes = _extends({}, (0, _omit2.default)(_UIModalDialog2.default.propTypes, ['centered', 'size', 'use']), {
  onCloseComplete: _react.PropTypes.func,
  onCloseStart: _react.PropTypes.func,
  onOpenComplete: _react.PropTypes.func,
  onOpenStart: _react.PropTypes.func,
  panelKey: (0, _decorators.hidden)(_react.PropTypes.string),
  _contextual: _react.PropTypes.bool
});

UIModalPanel.defaultProps = {
  width: 700,
  _contextual: false
};

UIModalPanel.displayName = 'UIModalPanel';

exports.default = UIModalPanel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/dialog/UIModalPanel.js
// module id = 540
// module chunks = 171